import React from "react";

import { TipsQuery } from "../../../../queries/educationTip/components/TipsQuery";
import { useUrlPath } from "../../../../queries/educationTip/components/TipsQuery/useUrlPath";
import { tipSummary } from "../../../../queries/educationTip/fragmentFields";
import { TipSliderBase } from "./TipSlider";
import { Placeholder } from "./TipsPlaceholder";

export const BaseTips: React.FC = () => {
  const path = useUrlPath();
  return (
    <TipsQuery fields={tipSummary} path={path}>
      {({ loading, data, error }) => {
        if (error) {
          throw error;
        }
        if (loading) {
          return <Placeholder />;
        }
        if (!data || !data.educations) {
          return null;
        }

        return <TipSliderBase educationTips={data.educations} />;
      }}
    </TipsQuery>
  );
};
